"use client";

import Script from "next/script";

import { useConfig } from "@jti/ui/providers/useConfig";

export function TrustPilot() {
  const { scriptPath, isEnabledForTenant } = useConfig();

  if (!isEnabledForTenant || !scriptPath) {
    return null;
  }

  // This component is actually rendered under the layout
  // but nested as it needs data from ConfigurationProvider
  // so the warning can be ignored
  // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
  return <Script src={scriptPath} strategy="beforeInteractive" />;
}
